import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'mechanic',
	prefix: 'mechanic',
	key: 'mechanic_id',
	fields: {
		mechanic_id: Model.SCHEMA_NUMBER,
		mechanic_name: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				mechanic_id: this.get_id(),
				mechanic_name: this.rawData().mechanic_name
			}
		}
	}
})
